
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hoat-dong-noi-bat-cua-lanh-dao/[...slug]",
      function () {
        return require("private-next-pages/hoat-dong-noi-bat-cua-lanh-dao/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hoat-dong-noi-bat-cua-lanh-dao/[...slug]"])
      });
    }
  